import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {RoutedTaskMarker} from "../../models/routed-task-marker.model";
import {MapLayersSettings} from "../../models/map-layers-settings.model";
import {MapsCommonService} from "../../services/mapsCommon.service";
import {MapPolygonDrawService, MapRectangleSelectSession, MapSelectionDrawSession} from "../../services/map-polygon-draw.service";
import {PlanningAlertsService} from "../../../planning/services/planning-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {StopsClusterModel} from "../../../planning/models/stops-cluster.model";
import {escapeHtml} from "../../../commons/utils/html-escape.util";
import {PlanningDragAndDropService} from "../../../planning/angular/services/planning-drag-and-drop.service";
import {PlanningDialogService} from "../../../planning/services/planning-dialogs-service.service";

declare var MarkerClusterer: any;

export class PlanningRoutesMapComponent implements IController {
  private static readonly DRAG_POLYLINE_TOLERANCE_PX = 24;

  routes: any;
  jobs: any;
  depots: any;
  stopsClusters?: any;
  hiddenRouteIds: any;
  unRoutedStops: any;
  serviceAreas: any;
  clusteringAreas: any;
  suggestions: any;
  selectedJobIds: any;
  selectedActivityId: any;
  zoomActivityId?: string;
  highlightedActivityId: any;
  isDisplayRetrips: boolean;
  isValidateRouteVehicles: boolean;
  isAllowDraggingStops: boolean;
  isAllowDraggingIntoDispatchedRoute: boolean;
  highlightedRouteIds: Set<string>;
  highlightedLeftoverIds: Set<string>;
  mapLayers?: MapLayersSettings;
  onMapLayersChange?: Function;
  onRoutedJobSelect: Function;
  onUnRoutedJobSelect: Function;
  onUnRoutedMultipleJobsSelect: Function;
  onActivityHover: Function;
  onActivityHighlight: Function;
  onRoutedActivitySelect: Function;
  onAddStopsToRoute: Function;
  onHiddenRouteIdsChange: Function;
  onSelectRoute: Function;
  onViewJob: Function;
  selectedServiceIdsChanged: Function;
  onMoveActivity: Function;

  onClusterToggle: Function;

  public circles = [];
  private siteLocation: any;
  private hoveredRoutePolyline: any = null;
  private multiDragOverlay: HTMLElement | null = null;
  private hiddenDragFeatures: google.maps.Data.Feature[] = [];
  private isDraggingFeature = false;
  private lastDragLatLng: google.maps.LatLng | null = null;
  private dragDomListeners: { dispose: () => void, cancel: () => void } | null = null;
  private dragPolylineCache: { feature: google.maps.Data.Feature, world: Float64Array, minX: number, maxX: number, minY: number, maxY: number }[] | null = null;
  private _listeners: google.maps.MapsEventListener[] = [];
  private mapTypeIds: any = {
    roadmap: 'ROADMAP',
    satellite: 'SATELLITE'
  };
  private infowindow: any = new google.maps.InfoWindow();
  private jobInfoWindow: any;
  private mapPolygonsWindow: any;
  private filters: any = {
    traffic: false,
    satellite: false,
    routes: true,
    serviceAreas: true,
    stopsTooltip: true,
    stopsTooltipSubset: false,
    serviceAreasTooltips: true,
    depots: true,
    unRouted: true,
    clusters: false
  };
  private isClustersLayerUserSet: boolean = false;
  private isClustersLayerAutoEnabled: boolean = false;
  // Polygons must stay clickable so they emit mouse events. In rectangle mode
  // those events are forwarded in polygonEvents so selection works over a polygon.
  private polygonConfig: any = {
    clickable: true
  };
  private clusterGridSizes: any = 70;
  private map: any;
  private tooltipOptions: any = {
    visible: false
  };
  private routedMarkers: any = [];
  private unRoutedMarkers: any = [];
  private polylines: any = [];
  private poligons: any = [];
  private routedMarkersControl: any = {};
  private unRoutedMarkersControl: any = {};
  private polylinesControl: any = {};
  private unRoutedMarkersEvents: any;
  private depotsEvents: any;
  private polygonEvents: any;
  private isReady: boolean;
  private selectedServiceIds: any;
  private mapPolygons: any[] = [];
  private clusteringAreaPolygons: any[] = [];
  private routesDataLayerRef: any;
  private jobInfoWindowModel: RoutedTaskMarker;
  private hoveringTaskId: any;
  private depotMarkers: any;
  private mapRef: any;
  public unRoutedDataLayerRef: any;
  public markerCluster: any;
  public jobsMap: any;
  drawSession: MapSelectionDrawSession;
  private pendingRectangleMode: boolean;
  private rectangleSelectSession: MapRectangleSelectSession;

  /* @ngInject */
  constructor(private mapsCommonService: MapsCommonService, private mapPolygonDrawService: MapPolygonDrawService, private $log, private $timeout: ITimeoutService,
              private planningAlertsService: PlanningAlertsService, private confirmDialogService: ConfirmDialogService, private mapUtilsService,
              private planningDragAndDropService: PlanningDragAndDropService, private planningDialogService: PlanningDialogService) {
  }

  $onDestroy() {
    this._unbindFeatureDragListeners();

    _.forEach(this._listeners, (listener) => {
      google.maps.event.removeListener(listener);
    });
    this._listeners = [];

    if (this.markerCluster) {
      this.clearCluster();
      this.markerCluster.setMap(null);
      this.markerCluster = null;
    }

    this.infowindow.close();
    this._hideMultiDragOverlay();
    this.dragPolylineCache = null;

    if (this.rectangleSelectSession) {
      this.rectangleSelectSession.destroy();
    }
    if (this.drawSession) {
      this.drawSession.destroy();
    }
  }

  $onInit() {
    this.drawSession = this.mapPolygonDrawService.createSelectionSession({
      $timeout: this.$timeout,
      polygonOptions: {},
      onRectangleComplete: () => {
      },
      onPolygonComplete: () => {
      },
      onDeleteCustomPolygons: () => {
      }
    });

    this.rectangleSelectSession = this.mapPolygonDrawService.createRectangleSelectSession({
      onComplete: (bounds) => {
        const jobIds = this.getJobIdsByBounds(bounds);
        if (jobIds.length && _.isFunction(this.onUnRoutedMultipleJobsSelect)) {
          this.$timeout(0).then(() => {
            this.onUnRoutedMultipleJobsSelect({jobIds: jobIds});
          });
        }
      },
      onModeChange: (mode) => {
        this._applyLayerClickability();
        if (this.map && this.map.options) {
          this.map.options.draggable = mode === 'pan';
        }
      }
    });

    this.siteLocation = this.mapsCommonService.getSiteLocation();
    this.jobInfoWindow = this.mapsCommonService.initActiveWindow();
    this.infowindow.setOptions({disableAutoPan: true})
    this.mapPolygonsWindow = this.mapsCommonService.initActiveWindow();

    this.jobsMap = _.keyBy(this.jobs, (j) => {
      return j.id
    })

    this.map = {
      isReady: false,
      center: this.siteLocation,
      zoom: 12,
      doCluster: true,
      events: {
        click: () => {
          if (this.rectangleSelectSession.consumeSkipNextClick()) {
            return;
          }
          this.$timeout(0).then(() => {
            this.onClusterToggle({ clusterId: '', routeIds: [], jobIds: [] });
          });
        },
        idle: (map) => {
          if (!this.isReady) {
            this.isReady = true;
            this.mapRef = map;
            google.maps.event.trigger(map, 'resize');
            this.centerMap();
            this.rectangleSelectSession.setMapInstance(map);
            this.drawSession.setMapInstance(map);
            if (this.pendingRectangleMode) {
              this.drawSession.showDrawToolbar = true;
              this.$timeout(0).then(() => {
                this.onSelectRectangleTool();
              });
            } else {
              this.drawSession.enable();
              this.rectangleSelectSession.setMode('pan');
            }
          }
        }
      },
      dataLayerCallback: (layer) => {
        this.routesDataLayerRef = layer;

        // Layer - Right Click Event
        this._listeners.push(this.routesDataLayerRef.addListener("rightclick", (event) => {
          this.$timeout(0).then(() => {
            const jobId = event.feature.getProperty("jobId");
            this.onViewJob({jobId: jobId});
          })
        }));

        let dragFeature: google.maps.Data.Feature | null = null;
        let initialMarkerPosition: any;
        let isDragging = false;

        this._listeners.push(this.routesDataLayerRef.addListener("mousedown", (event) => {
          const self = this;
          const feature = event.feature;
          if (this.rectangleSelectSession.isRectangleActive()) {
            return;
          }
          if (feature.getGeometry().getType() === "Point") {
            initialMarkerPosition = (feature.getGeometry() as google.maps.Data.Point).get();
            this.map.options.draggable = false;
            isDragging = false;
            this.isDraggingFeature = false;
            this.lastDragLatLng = null;

            dragFeature = feature;

            // Check if dragging multiple selected tasks
            const clickedJobIds = feature.getProperty("jobIds") || [feature.getProperty("jobId")];
            const isPartOfSelection = clickedJobIds.some(jobId => this.selectedJobIds?.includes(jobId));
            const isDraggingMultiple = isPartOfSelection && this.selectedJobIds?.length > 1;

            const onDrop = (upEvent) => {
              this.map.options.draggable = true;

              if (!dragFeature) {
                return;
              }

              const marker = dragFeature;

              if (!isDragging) {
                cancelDrag();
                return;
              }

              if (!marker || marker.getGeometry().getType() !== "Point") {
                cancelDrag();
                return;
              }

              const markerPosition = (marker.getGeometry() as google.maps.Data.Point).get();
              const routePolyline = this._getClosestDragPolyline(markerPosition);
              if (!routePolyline) {
                cancelDrag();
                return;
              }

              const fromRouteId: any = marker.getProperty("routeId");
              const toRouteId = routePolyline.getProperty("routeId") as string;

              let selectedGroups: { routeId: string; jobIds: string[] }[];
              if (isDraggingMultiple) {
                selectedGroups = this._getSelectedRoutedJobsByRoute();
              } else {
                const markerJobIds: any = marker.getProperty("jobIds") ? marker.getProperty("jobIds") : [marker.getProperty("jobId")];
                selectedGroups = [{routeId: fromRouteId, jobIds: markerJobIds}];
              }

              const isAlreadyInTargetRoute = selectedGroups.some((group) => group.routeId === toRouteId);

              // Jobs already on the target route cannot move, and a group whose route is not loaded
              // must neither reach the payload nor skip the validations below - keep both lists in sync.
              const fromRoutes = [];
              const sourceRouteJobs = selectedGroups.filter((group) => {
                if (group.routeId === toRouteId) {
                  return false;
                }
                const route = this.routes.find((r) => r.id === group.routeId);
                if (route) {
                  fromRoutes.push(route);
                }
                return !!route;
              });

              const jobIds: any = _.flatMap(sourceRouteJobs, 'jobIds');
              const toRoute = this.routes.find((route) => route.id === toRouteId);

              if (!sourceRouteJobs.length || !toRoute) {
                if (toRoute && isAlreadyInTargetRoute) {
                  this.planningAlertsService.alreadyInRouteInfo();
                }
                cancelDrag();
                return;
              }

              if (fromRoutes.some((route) => route.locked) || toRoute.locked) {
                this.planningAlertsService.routeIsLocked();
                cancelDrag();
                return;
              }

              if (!this.isAllowDraggingIntoDispatchedRoute && (fromRoutes.some((route) => route.status === 'DISPATCHED' || route.status === 'PARTIAL_DISPATCHED') || toRoute.status === 'DISPATCHED' || toRoute.status === 'PARTIAL_DISPATCHED')) {
                this.planningAlertsService.routeIsDispatchedOrPartialDispatchedInfo();
                cancelDrag();
                return;
              }

              const itemJobs = _.map(jobIds, (id) => {
                return this.jobsMap[id];
              })

              const toRouteActivities = toRoute.activities.filter(activity => (activity.type !== 'START') && (activity.type !== 'END'))

              const skillWarnings = this.planningDialogService.getJobsSkillMismatchWarnings(itemJobs, toRoute.resource);
              const hasSkillMismatch = skillWarnings.length > 0;

              let isValidateRouteVehicle = false;
              for (let job of itemJobs) {
                const jobVehicleTypes = _.map(job.allowedVehicleReferences, 'type');
                if (this.isValidateRouteVehicles && !!toRoute.resource?.vehicleClass &&
                  jobVehicleTypes?.length && !jobVehicleTypes.includes(toRoute.resource?.vehicleClass)) {
                  isValidateRouteVehicle = true;
                  break;
                }
              }

              const proceedWithDrop = () => {
                if (isValidateRouteVehicle) {
                  const confirmDialogDescription = itemJobs.length > 1 ? "Services vehicle types do not match route resource vehicle type. Are you sure you want to proceed?" :
                    "Service vehicle types do not match route resource vehicle type. Are you sure you want to proceed?"
                  this.confirmDialogService.confirm("Confirm",
                    confirmDialogDescription)
                    .then(() => {
                      activityDrop(upEvent, hasSkillMismatch);
                    })
                    .catch(() => {
                      cancelDrag();
                      return;
                    });
                } else {
                  activityDrop(upEvent, hasSkillMismatch);
                }
              };

              if (hasSkillMismatch) {
                this.planningDialogService.openJobAssignWarnings(skillWarnings, upEvent)
                  .then(proceedWithDrop)
                  .catch(() => {
                    cancelDrag();
                  });
              } else {
                proceedWithDrop();
              }

              function activityDrop(event, allowSkillsMismatch?: boolean) {
                if (routePolyline && !_.includes(self.hiddenRouteIds, toRouteId)) {

                  const routePolylinePath = (routePolyline.getGeometry() as google.maps.Data.LineString)
                    .getArray()
                    .map(latLng => ({lat: latLng.lat(), lng: latLng.lng()}));

                  let toOrderedIds;
                  if (isDraggingMultiple) {
                    // For multiple tasks, calculate position and maintain order
                    toOrderedIds = self._activityOrderIdsMultiple(
                      marker,
                      jobIds,
                      fromRoutes,
                      toRouteActivities,
                      routePolylinePath
                    );
                  } else {
                    toOrderedIds = self._activityOrderIds(marker, toRouteActivities, routePolylinePath);
                  }

                  let pickupIndex: number | undefined;
                  let destinationIndex: number | undefined;

                  const job = _.find(self.jobs, {id: jobIds[0]});
                  const stopType = (marker.getProperty('ref') as any)?.stopType;

                  if (job) {
                    const activitiesCoordinates: google.maps.LatLng[] = toRouteActivities.map(activity => new google.maps.LatLng(activity.address.location));
                    const markerLatLng = (marker.getGeometry() as google.maps.Data.Point).get();
                    const i = self._getBundledStopIndex(job, stopType, self.mapUtilsService.getInsertionIndex(markerLatLng, activitiesCoordinates), toRouteActivities);

                    if (i >= 0 && stopType === 'Pickup') {
                      pickupIndex = i;
                    } else if (i >= 0 && stopType === 'Dropoff') {
                      destinationIndex = i;
                    }
                  }

                  self.onMoveActivity({
                    jobIds: jobIds,
                    fromRouteId: fromRouteId,
                    toRouteId: toRouteId,
                    toOrderedIds: toOrderedIds,
                    pickupIndex: pickupIndex,
                    destinationIndex: destinationIndex,
                    sourceRouteJobs: sourceRouteJobs,
                    allowSkillsMismatch: allowSkillsMismatch
                  });
                }

                cancelDrag();
              }
            };

            const setMarkerToInitialPosition = () => {
              if (dragFeature && initialMarkerPosition) {
                dragFeature.setGeometry(
                  new google.maps.Data.Point(initialMarkerPosition)
                );
              }
            };

            const cancelDrag = () => {
              setMarkerToInitialPosition();

              self._unbindFeatureDragListeners();

              // Unhighlight any highlighted route
              self._unhighlightRoutePolyline();

              // Hide multi-drag overlay and restore hidden features
              self._hideMultiDragOverlay();
              self._showHiddenFeatures();

              isDragging = false;
              self.isDraggingFeature = false;
              self.dragPolylineCache = null;
              dragFeature = null;
            };

            this._bindFeatureDragListeners({
              onMove: (moveEvent) => {
                if (!isDragging) {
                  isDragging = true;
                  this.isDraggingFeature = true;
                  if (isDraggingMultiple) {
                    this._showMultiDragOverlay(this.selectedJobIds.length, moveEvent);
                    // Hide all selected task markers except the one being dragged
                    this._hideSelectedFeatures(this.routesDataLayerRef, feature);
                  }
                }

                if (dragFeature) {
                  dragFeature.setGeometry(
                    new google.maps.Data.Point(moveEvent.latLng)
                  );
                  this.mapUtilsService.autoPanIfNearEdge(moveEvent.pixel, this.mapRef);

                  // Update multi-drag overlay position
                  if (isDraggingMultiple) {
                    this._updateMultiDragOverlayPosition(moveEvent.pixel);
                  }

                  // Check if hovering over a route and highlight it
                  const hoveredPolyline = this._getClosestDragPolyline(moveEvent.latLng);
                  if (hoveredPolyline) {
                    this._highlightRoutePolyline(hoveredPolyline);
                  } else {
                    this._unhighlightRoutePolyline();
                  }
                }
              },
              onUp: onDrop,
              onCancel: cancelDrag
            }, event.domEvent);

          }
        }));

        // Layer - Click Event
        this._listeners.push(this.routesDataLayerRef.addListener("click", (event) => {
          this.$timeout(0).then(() => {
            const routeId = event.feature.getProperty("routeId");
            const jobIds = event.feature.getProperty("jobId") ? [event.feature.getProperty("jobId")] : event.feature.getProperty("jobIds");
            const type = event.feature.getProperty("type");
            this.onSelectRoute({routeId: routeId, $event: event});
            if (type === 'STOP' || type === 'GROUP') {
              this.onUnRoutedMultipleJobsSelect({jobIds: jobIds});
            }
          })
        }));

        // Layer - Mouseover
        this._listeners.push(this.routesDataLayerRef.addListener("mouseover", (event) => {
          if (this.isDraggingFeature || !this.filters.stopsTooltip) return;
          const activityType = event.feature.getProperty("type");
          if (activityType === 'STOP' || activityType === 'GROUP') {
            this.$timeout(0).then(() => {
              const activity = angular.copy(event.feature.getProperty("ref"));
              const jobId = event.feature.getProperty("jobId");
              const geo = (event.feature.getGeometry() as google.maps.Data.Point).get();
              this.setActivityInfoWindow(jobId, activity, geo.lat(), geo.lng());
            })
          }
        }));

        // Layer - Mouseout
        this._listeners.push(this.routesDataLayerRef.addListener("mouseout", (event) => {
          this.$timeout(0).then(() => {
            this.unsetActivityInfoWindow();
          });
        }));

        if (this.routes) {
          this.setRoutes(this.routes);
        }

      },
      layerEnable: true,
      unRoutedLayerEnabled: false,
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        scaleControl: true,
        mapTypeControl: false
      },
      clusterOptions: {
        imagePath: 'https://raw.githubusercontent.com/googlemaps/js-marker-clusterer/gh-pages/images/m',
        gridSize: this.clusterGridSizes,
        maxZoom: 23,
        styles: this.mapsCommonService.getClusterIcons()
        // zoomOnClick: false,
      },
      bounds: {},
      unRoutedLayerCallback: (layer) => {
        this.unRoutedDataLayerRef = layer;

        let dragFeature: google.maps.Data.Feature | null = null;
        let initialMarkerPosition: any;
        let isDragging = false;

        this._listeners.push(this.unRoutedDataLayerRef.addListener("mousedown", (event) => {
          const self = this;
          const feature = event.feature;
          if (this.rectangleSelectSession.isRectangleActive()) {
            return;
          }
          if (feature.getGeometry().getType() === "Point") {
            isDragging = false;
            this.isDraggingFeature = false;
            this.lastDragLatLng = null;
            this.map.options.draggable = false;
            initialMarkerPosition = (feature.getGeometry() as google.maps.Data.Point).get();

            dragFeature = feature;

            // Check if dragging multiple selected tasks
            const clickedJobIds = feature.getProperty("jobIds") || [feature.getProperty("jobId")];
            const isPartOfSelection = clickedJobIds.some(jobId => this.selectedJobIds?.includes(jobId));
            const isDraggingMultiple = isPartOfSelection && this.selectedJobIds?.length > 1;

            const onDrop = (upEvent) => {
              this.map.options.draggable = true;

              if (!dragFeature) {
                return;
              }

              const marker = dragFeature;

              if (!isDragging) {
                cancelDrag();
                return;
              }

              if (!marker || marker.getGeometry().getType() !== "Point") {
                cancelDrag();
                return;
              }

              const markerPosition = (marker.getGeometry() as google.maps.Data.Point).get();
              const routePolyline = this._getClosestDragPolyline(markerPosition);
              if (!routePolyline) {
                cancelDrag();
                return;
              }
              const toRouteId = routePolyline.getProperty("routeId");

              const toRoute = this.routes.find((route) => route.id === toRouteId);

              if (!toRoute) {
                cancelDrag();
                return;
              }

              if (toRoute.locked) {
                this.planningAlertsService.routeIsLocked();
                cancelDrag();
                return;
              }

              if (!this.isAllowDraggingIntoDispatchedRoute && (toRoute.status === 'DISPATCHED' || toRoute.status === 'PARTIAL_DISPATCHED')) {
                this.planningAlertsService.routeIsDispatchedOrPartialDispatchedInfo();
                cancelDrag();
                return;
              }

              let jobIds: any;
              if (isDraggingMultiple) {
                jobIds = this._getSelectedUnroutedJobs();
              } else {
                jobIds = marker.getProperty("jobIds") ? marker.getProperty("jobIds") : [marker.getProperty("jobId")];
              }

              const toRouteActivities = toRoute.activities.filter(activity => (activity.type !== 'START') && (activity.type !== 'END'));

              const mockEvent: any = {
                isPointerOverContainer: true,
                item: {
                  data: {
                    id: jobIds[0],
                    jobIds: jobIds,
                    jobType: 'Leftover'
                  }
                },
                currentIndex: 0
              };

              this.planningDragAndDropService.onDropRouteActivities(
                mockEvent,
                jobIds,
                this.jobsMap,
                toRoute,
                this.isValidateRouteVehicles,
                this.isAllowDraggingIntoDispatchedRoute,
                this.jobs
              ).then((result) => {
                if (!result || !this.hoveredRoutePolyline) {
                  cancelDrag();
                  return;
                }
                activityDrop(result.allowSkillsMismatch);
              }).catch(() => {
                cancelDrag();
              });

              function activityDrop(allowSkillsMismatch?: boolean) {
                if (routePolyline) {

                  const routePolylinePath = (routePolyline.getGeometry() as google.maps.Data.LineString)
                    .getArray()
                    .map(latLng => ({lat: latLng.lat(), lng: latLng.lng()}));

                  let toOrderedIds;
                  if (isDraggingMultiple) {
                    // For multiple unrouted tasks, calculate position and maintain order
                    toOrderedIds = self._activityOrderIdsMultipleUnrouted(
                      marker,
                      jobIds,
                      toRouteActivities,
                      routePolylinePath
                    );
                  } else {
                    toOrderedIds = self._activityOrderIds(marker, toRouteActivities, routePolylinePath);
                  }

                  let pickupIndex: number | undefined;
                  let destinationIndex: number | undefined;

                  const job = _.find(self.jobs, {id: jobIds[0]});
                  const ref: any = marker.getProperty('ref');
                  const stopType = ref?.stopType;

                  if (job) {
                    const activitiesCoordinates: google.maps.LatLng[] = toRouteActivities.map(activity => new google.maps.LatLng(activity.address.location));
                    const markerLatLng = (marker.getGeometry() as google.maps.Data.Point).get();
                    const i = self._getBundledStopIndex(job, stopType, self.mapUtilsService.getInsertionIndex(markerLatLng, activitiesCoordinates), toRouteActivities);

                    if (i >= 0 && stopType === 'Pickup') {
                      pickupIndex = i;
                    } else if (i >= 0 && stopType === 'Dropoff') {
                      destinationIndex = i;
                    }
                  }

                  self.onMoveActivity({
                    jobIds: jobIds,
                    fromRouteId: undefined,
                    toRouteId: toRouteId,
                    toOrderedIds: toOrderedIds,
                    pickupIndex: pickupIndex,
                    destinationIndex: destinationIndex,
                    allowSkillsMismatch: allowSkillsMismatch
                  });
                }

                cancelDrag();
              }
            };

            const setMarkerToInitialPosition = () => {
              if (dragFeature && initialMarkerPosition) {
                dragFeature.setGeometry(
                  new google.maps.Data.Point(initialMarkerPosition)
                );
              }
            };

            const cancelDrag = () => {
              setMarkerToInitialPosition();

              self._unbindFeatureDragListeners();

              // Unhighlight any highlighted route
              self._unhighlightRoutePolyline();

              // Hide multi-drag overlay and restore hidden features
              self._hideMultiDragOverlay();
              self._showHiddenFeatures();

              isDragging = false;
              self.isDraggingFeature = false;
              self.dragPolylineCache = null;
              dragFeature = null;
            };

            this._bindFeatureDragListeners({
              onMove: (moveEvent) => {
                if (!isDragging) {
                  isDragging = true;
                  this.isDraggingFeature = true;
                  if (isDraggingMultiple) {
                    this._showMultiDragOverlay(this.selectedJobIds.length, moveEvent);
                    // Hide all selected task markers except the one being dragged
                    this._hideSelectedFeatures(this.unRoutedDataLayerRef, feature);
                  }
                }

                if (dragFeature) {
                  dragFeature.setGeometry(
                    new google.maps.Data.Point(moveEvent.latLng)
                  );
                  this.mapUtilsService.autoPanIfNearEdge(moveEvent.pixel, this.mapRef);

                  // Update multi-drag overlay position
                  if (isDraggingMultiple) {
                    this._updateMultiDragOverlayPosition(moveEvent.pixel);
                  }

                  // Check if hovering over a route and highlight it
                  const hoveredPolyline = this._getClosestDragPolyline(moveEvent.latLng);
                  if (hoveredPolyline) {
                    this._highlightRoutePolyline(hoveredPolyline);
                  } else {
                    this._unhighlightRoutePolyline();
                  }
                }
              },
              onUp: onDrop,
              onCancel: cancelDrag
            }, event.domEvent);

          }
        }));

        // Layer - Click Event
        this._listeners.push(this.unRoutedDataLayerRef.addListener("click", (event) => {
          this.$timeout(0).then(() => {
            const routeId = event.feature.getProperty("routeId");
            const jobIds = event.feature.getProperty("jobId") ? [event.feature.getProperty("jobId")] : event.feature.getProperty("jobIds");
            const id = event.feature.getProperty("id");
            const type = event.feature.getProperty("type");
            this.onSelectRoute({routeId: routeId, $event: event});
            if (type === 'STOP' || type === 'GROUP') {
              this.onUnRoutedMultipleJobsSelect({jobIds: jobIds});

              // const route = _.find(this.routes, (r) => {
              //   return r.id === routeId;
              // })
              // if (!!route) {
              //   const activity = _.find(route.activities, (a) => {
              //     return a.id === id;
              //   })
              //   this.onActivityHighlight({activity: activity});
              // }
              // this.onRoutedJobSelect({jobId: jobId});
            }
          })
        }));

        // Add events connection to data layer
        this._listeners.push(this.unRoutedDataLayerRef.addListener("click", (event) => {
          this.$timeout(0).then(() => {
            const jobId = event.feature.getProperty("jobId");
            this.onUnRoutedJobSelect({jobId: jobId})
          });
        }));

        // Add events connection to data layer
        this._listeners.push(this.unRoutedDataLayerRef.addListener("rightclick", (event) => {
          this.$timeout(0).then(() => {
            const jobId = event.feature.getProperty("jobId");
            this.onViewJob({jobId: jobId})
          });
        }));

        this._listeners.push(this.unRoutedDataLayerRef.addListener("mouseover", (event) => {
          if (this.isDraggingFeature || !this.filters.stopsTooltip) return;
          this.$timeout(0).then(() => {
            const jobId = event.feature.getProperty("jobId");
            const model = event.feature.getProperty("ref");
            const coordinates = event.feature.getProperty('coordinates');
            this.setActivityInfoWindow(jobId, model, coordinates.lat, coordinates.lng);
          })
        }));

        this._listeners.push(this.unRoutedDataLayerRef.addListener("mouseout", (event) => {
          this.$timeout(0).then(() => {
            this.unsetActivityInfoWindow();
          })
        }));

        if (this.unRoutedStops?.length) {
          this.setUnRoutedMarkersOnLayer(this.unRoutedStops);
          this.centerMap();
        }


      },
    };
    this.depotsEvents = {
      mouseover: (marker, event, model, args) => {
        const map = marker.map;
        this.infowindow.setContent(escapeHtml(model.name));
        this.infowindow.open(map, marker);
      },
      mouseout: (marker, event, model, args) => {
        this.infowindow.close();
      }
    };
    this.polygonEvents = {
      mouseover: (marker, event, model) => {
        if (this.isDraggingFeature) {
          return;
        }
        if (this.filters.serviceAreasTooltips && !this.rectangleSelectSession.isDrawingRectangle()) {
          const map = marker.map;
          const contentString =
            '<div style="text-align: center; width: 100%">' + escapeHtml(_.get(model, 'fill.name')) + '</div>';
          this.infowindow.setPosition(this.mapsCommonService.getPolygonBounds(model.path).getCenter());
          this.infowindow.setContent(contentString);
          this.infowindow.open(map, marker);
        }
      },
      mouseout: () => {
        if (this.filters.serviceAreasTooltips) {
          this.infowindow.close();
        }
      },
      mousedown: (polygon, eventName, model, args) => {
        this.rectangleSelectSession.handleMouseDown(_.get(args, '0'));
      },
      mousemove: (polygon, eventName, model, args) => {
        this.rectangleSelectSession.handleMouseMove(_.get(_.get(args, '0'), 'latLng'));
      },
      mouseup: () => {
        this.rectangleSelectSession.handleMouseUp();
      }
    };

    if (!this.routes) {
      this.routes = [];
    }

    if (!this.unRoutedStops) {
      this.unRoutedStops = [];
    }

    // Restore the persisted layer toggles before drawing, so the initial styles/polygons are
    // built with the user's choices instead of the hard-coded defaults.
    this._restoreMapLayers();

    this._syncRoutesFilter();

    // _addRoutes(this.routes);

    this.setRoutes(this.routes);

    this.depotMarkers = this.mapsCommonService.getDepotMarkers(this.depots);

    // this.routesDataLayerRef.setMap(null);
    // this.routesDataLayerRef.setMap(this.mapRef);
  }

  $onChanges(changes) {
    // Jobs Changed
    if (changes.jobs) {
      this.jobsMap = _.keyBy(this.jobs, (j) => j.id);
    }

    // Routes Changed
    if (changes.routes && !changes.routes.isFirstChange()) {
      const currentRoutes = changes.routes.currentValue;
      const previousRoutes = changes.routes.previousValue;

      const routesToAdd = _.differenceBy(currentRoutes, previousRoutes, 'id');
      const routesToRemove = _.differenceBy(previousRoutes, currentRoutes, 'id');

      const routesDelta = _.differenceBy(currentRoutes, routesToAdd.concat(routesToRemove), 'id');
      const routesToUpdate = _.filter(routesDelta, (rd: any) => {
        const previousRoute = _.find(previousRoutes, ['id', rd.id]);
        const hasSameActivitiesLength = previousRoute?.activities.length === rd.activities.length;

        return previousRoute ? (previousRoute.updatedAt < rd.updatedAt || !hasSameActivitiesLength) : true;
      })


      //Clear features from datalayer
      const routeIdsToRemove = _.map(routesToRemove.concat(routesToUpdate), 'id');
      this.removeRoutesByIds(routeIdsToRemove);

      //Add routes features to datalayer
      this.setRoutes(_.concat(routesToAdd, routesToUpdate));

      // The 'Planned Routes' checkbox reflects the hidden/visible ratio, so it has to follow
      // the route set as well - not only hiddenRouteIds changes.
      this._syncRoutesFilter();

      if (!previousRoutes?.length && !!currentRoutes?.length) {
        this.centerMap();
      }
    }

    if (changes.depots && !changes.depots.isFirstChange()) {
      this.depotMarkers = this.mapsCommonService.getDepotMarkers(this.depots);
    }

    if (changes.stopsClusters) {
      this.circles = this.stopsClusters?.length ?
        _.map(this.stopsClusters, (sc: StopsClusterModel) => {
          return this.mapsCommonService.getPlanningCluster(sc, () => {
            this._handleClusterClick(sc);
          });
        }) : [];
    }

    // Hide Routes Changed
    if (changes.hiddenRouteIds && !changes.hiddenRouteIds.isFirstChange()) {
      if (!_.isEqual(changes.hiddenRouteIds.previousValue, changes.hiddenRouteIds.currentValue)) {
        this._syncRoutesFilter();

        // Set feature style by its properties
        this.setRoutesStyle();
      }
    }

    // un Routed Stops Changed
    if (changes.unRoutedStops && !changes.unRoutedStops.isFirstChange()) {

      const currentStops = changes.unRoutedStops.currentValue;
      const previousStops = changes.unRoutedStops.previousValue;

      const stopsToAdd = _.differenceBy(currentStops, previousStops, 'id');
      const stopsToRemove = _.differenceBy(previousStops, currentStops, 'id');

      this._removeUnRoutedMarkers(_.map(stopsToRemove, 'id'));
      this.setUnRoutedMarkersOnLayer(stopsToAdd);

      if (!currentStops?.length && !!previousStops?.length) {
        this.centerMap();
      }
    }

    if (changes.serviceAreas && !changes.serviceAreas.isFirstChange()) {
      this.mapPolygons = this.mapsCommonService.buildPolygons(this.serviceAreas, this.filters.serviceAreas);
    }

    if (changes.clusteringAreas) {
      this._setClusteringAreaPolygons();
    }

    if (changes.selectedJobIds && !changes.selectedJobIds.isFirstChange()) {
      const changedJobIds: string[] = _.xor(changes.selectedJobIds.previousValue || [], changes.selectedJobIds.currentValue || []);

      if (changedJobIds.length) {
        if (this.unRoutedDataLayerRef) {
          this._updateFeatureSelectionByJobIds(this.unRoutedDataLayerRef, changedJobIds);
        }

        if (this.routesDataLayerRef) {
          this._updateFeatureSelectionByJobIds(this.routesDataLayerRef, changedJobIds);
        }
      }
    }

    if (changes.zoomActivityId && !changes.zoomActivityId.isFirstChange()) {
      if (this.routesDataLayerRef) {
        let activityMarker;
        let routeId;

        this.routesDataLayerRef.forEach((feature) => {
          const featureId = feature.getProperty('id')
          if (featureId === this.zoomActivityId) {
            const coordinates = feature.getProperty('coordinates');
            routeId = feature.getProperty('routeId')

            activityMarker = new google.maps.MVCObject();
            activityMarker.set('coords', {'latitude': coordinates.lat, 'longitude': coordinates.lng});
          }
        });

        if (!!activityMarker) {
          this.mapsCommonService.centerMapByBounds(this.map, [activityMarker]);
          if (_.includes(this.hiddenRouteIds, routeId)) {
            this.onHiddenRouteIdsChange({
              ids: _.filter(this.hiddenRouteIds, (rid) => {
                return rid !== routeId;
              })
            });
          }
          this.$timeout(100).then(() => {
            this.map.zoom = 16;
          })
        }
      }
    }

    if (changes.highlightedActivityId && !changes.highlightedActivityId.isFirstChange()) {
      if (_.isFunction(this.routedMarkersControl.getGMarkers)) {
        const routeMarkers = this.routedMarkersControl.getGMarkers(),
          currentHighlightedId = changes.highlightedActivityId.currentValue,
          previousHighlightedId = changes.highlightedActivityId.previousValue;

        const markersToUpdate = _.chain(routeMarkers)
          .map((marker, i) => {
            return {ref: marker, index: i}
          })
          .filter((m) => {
            const markerId = m.ref.model.id;
            return markerId === currentHighlightedId || markerId === previousHighlightedId;
          })
          .value();

        _.forEach(markersToUpdate, (m, i) => {
          const isHighlighted = _.isEqual(m.ref.model.id, this.highlightedActivityId);
          this.setGoogleMarkerIcon(m.ref, this.selectedActivityId, this.highlightedActivityId);
          m.ref.setZIndex(this.mapsCommonService.getRoutedActivityMarkerZIndex(m.ref, isHighlighted, m.ref.model.markerIndex))
        });

        // _.forEach(routeMarkers, function(routedMarker, i) {
        //     var isHighlighted = _.isEqual(routedMarker.models.id, ctrl.highlightedActivityId);
        //     _setGoogleMarkerIcon(routedMarker, ctrl.selectedActivityId, ctrl.highlightedActivityId);
        //     routedMarker.setZIndex(mapsCommon.getRoutedActivityMarkerZIndex(routedMarker, isHighlighted, i))
        // });
      }
    }

    if (changes.highlightedRouteIds && !changes.highlightedRouteIds.isFirstChange()) {

      // using 'any' here since we use an older version of ecma script
      // missing the prototype for 'symmetricDifference'
      const current: any = changes.highlightedRouteIds.currentValue || new Set();
      const previous: any = changes.highlightedRouteIds.previousValue || new Set();
      const routeIdsToUpdate: Set<string> = current.symmetricDifference(previous);
      const routesToUpdate = !this.highlightedRouteIds || (this.highlightedRouteIds && !routeIdsToUpdate.size) ? this.routes : this.routes.filter(r => routeIdsToUpdate.has(r.id));

      this.removeRoutesByIds(Array.from(routeIdsToUpdate));
      this.setRoutes(routesToUpdate);
    }

    if (changes.highlightedLeftoverIds && !changes.highlightedLeftoverIds.isFirstChange()) {

      // using 'any' here since we use an older version of ecma script
      // missing the prototype for 'symmetricDifference'
      const current: any = changes.highlightedLeftoverIds.currentValue || new Set();
      const previous: any = changes.highlightedLeftoverIds.previousValue || new Set();
      const leftoverIdsToUpdate: Set<string> = current.symmetricDifference(previous);
      const leftoversToUpdate = !this.highlightedLeftoverIds || (this.highlightedLeftoverIds && !leftoverIdsToUpdate.size) ? this.unRoutedStops : this.unRoutedStops.filter(r => leftoverIdsToUpdate.has(r.id));

      this._removeUnRoutedMarkers(Array.from(leftoverIdsToUpdate));
      this.setUnRoutedMarkersOnLayer(leftoversToUpdate);
    }
  }


  // ******************************
  //        Public methods
  // ******************************

  // onToggleUnRouted() {
  //   if (!this.filters.unRouted) {
  //     this.map.doCluster = false;
  //   }
  //   this.setUnRoutedStopsVisibility();
  // }

  onToggleUnRouted(isEnabled) {
    this._applyUnRoutedLayer(isEnabled);
    this._emitMapLayersChange();
  }

  private _applyUnRoutedLayer(isEnabled) {
    if (isEnabled) {
      if (this.map.doCluster) {
        this._applyClusters(true);
        this.map.unRoutedLayerEnabled = false;
      } else {
        this.map.unRoutedLayerEnabled = true;
      }
    } else {
      this.map.unRoutedLayerEnabled = false;
      this.clearCluster();
    }
  }

  private _removeUnRoutedMarkers(removeIds?) {
    if (this.unRoutedDataLayerRef) {
      this.unRoutedDataLayerRef.forEach((feature) => {
        if (!removeIds || _.includes(removeIds, feature.getProperty('id'))) {
          this.unRoutedDataLayerRef.remove(feature);
        }
      });
    }
  }

  private setUnRoutedMarkersOnLayer(stops) {
    if (this.unRoutedDataLayerRef) {
      let geoJson = this.mapsCommonService.convertStopsToGeoJson(stops, this.isAllowDraggingStops);

      // Add routes to layer
      this.unRoutedDataLayerRef.addGeoJson(geoJson);

      // Set feature style by its properties
      this.unRoutedDataLayerRef.setStyle((feature) => {
        return this.unRoutedFeatureStyle(feature);
      });

      if (!!this.map.doCluster) {
        this.reInitCluster();
      }
    }
  }

  private unRoutedFeatureStyle(feature) {
    let jobId = feature.getProperty('jobId'),
      purpose = feature.getProperty('purpose');

    const isSelected = _.isBoolean(feature.getProperty('isSelected')) ?
      feature.getProperty('isSelected') :
      _.indexOf(this.selectedJobIds, jobId) !== -1;
    const isDimmed = this.highlightedLeftoverIds && !this.highlightedLeftoverIds.has(jobId);

    return {
      visible: this.filters.unRouted && !isDimmed,
      icon: this.mapsCommonService.getTaskMarkerIconNew(purpose, undefined, isSelected),
      clickable: !this.rectangleSelectSession?.isRectangleActive()
    }
  }

  private getRouteFeatureStyle(feature) {
    const routeId = feature.getProperty('routeId'),
      featureType = feature.getProperty('type'),
      isPolyline = _.isEqual(featureType, 'POLYLINE'),
      jobIds = this._getFeatureJobIds(feature),
      // hiddenRouteIds is the single source of truth for route visibility. filters.routes is only
      // the rendered state of the 'Planned Routes' checkbox and must not gate visibility, or the
      // two desync (routes invisible while every eye icon reads "on").
      isVisible = !_.includes(this.hiddenRouteIds, routeId),
      isSelected = _.isBoolean(feature.getProperty('isSelected')) ?
        feature.getProperty('isSelected') :
        jobIds.some(jobId => this.selectedJobIds?.includes(jobId)),
      isDimmed = this.highlightedRouteIds && !this.highlightedRouteIds.has(routeId);

    const style = this.mapsCommonService.getActivityFeatureStyle(feature, isVisible, isSelected, this.isDisplayRetrips, undefined, isDimmed);
    // Polylines cover the map and swallow drag/click — keep them non-interactive so
    // stop markers and TerraDraw rectangle selection still receive events.
    return {...style, clickable: isPolyline ? false : !this.rectangleSelectSession?.isRectangleActive()};
  }

  onMapTypeChange(isSatelliteEnabled) {
    this._applyMapType(isSatelliteEnabled);
    this._emitMapLayersChange();
  }

  private _applyMapType(isSatelliteEnabled) {
    this.map.options.mapTypeId = google.maps.MapTypeId[isSatelliteEnabled ? this.mapTypeIds.satellite : this.mapTypeIds.roadmap];
    if (isSatelliteEnabled) {
      this.filters.traffic = false;
    }
  }

  centerMap() {
    this.$timeout(0).then(() => {
      const markers = this.getAllMarkers();
      this.mapsCommonService.centerMapByBounds(this.map, markers);
    })
  }

  onToggleRoutes() {
    const ids = this.filters.routes ? [] : _.map(this.routes, 'id');
    this.onHiddenRouteIdsChange({ids: ids});
  }

  onSelectHandTool() {
    this.pendingRectangleMode = false;
    this.drawSession.selectHandTool();
    this.rectangleSelectSession.setMode('pan');
  }

  onSelectRectangleTool() {
    this.pendingRectangleMode = true;
    this.drawSession.drawToolMode = 'rectangle';
    this.rectangleSelectSession.setMode('rectangle');
  }

  private _applyLayerClickability() {
    this.setRoutesStyle();
    if (this.unRoutedDataLayerRef) {
      this.unRoutedDataLayerRef.setStyle((feature) => {
        return this.unRoutedFeatureStyle(feature);
      });
    }
  }

  onToggleServiceAreas() {
    this._applyServiceAreasVisibility();
    this._emitMapLayersChange();
  }

  private _applyServiceAreasVisibility() {
    _.forEach(this.mapPolygons, (mapPolygon) => {
      mapPolygon.visible = this.filters.serviceAreas;
    });
  }

  onToggleClusters() {
    this.isClustersLayerUserSet = true;
    this._applyClusteringAreasVisibility();
    this._emitMapLayersChange();
  }

  private _applyClusteringAreasVisibility() {
    _.forEach(this.clusteringAreaPolygons, (mapPolygon) => {
      mapPolygon.visible = this.filters.clusters;
    });
  }

  // Called from the checkboxes that only flip a filters.* flag consumed declaratively by the
  // template (traffic, depots, tooltips) - they need no imperative work beyond persisting.
  onPersistLayers() {
    this._emitMapLayersChange();
  }

  // function onRoutedMarkerSelect(marker, eventName, model) {
  //     if (model.type === 'STOP') {
  //         ctrl.onRoutedStopSelect({stop: model.ref})
  //     }
  // }

  onUnRoutedMarkerSelect(marker, eventName, model) {
    this.onUnRoutedJobSelect({jobId: model.jobId})
  }

  onCloseTooltip() {
    this.tooltipOptions.visible = false;
  }

  onSetClusters(isEnabled) {
    this._applyClusters(isEnabled);
    this._emitMapLayersChange();
  }

  private _applyClusters(isEnabled) {
    this.map.doCluster = isEnabled;

    if (isEnabled) {
      this.reInitCluster();
    } else {
      this.clearCluster();
      this.map.unRoutedLayerEnabled = true;
    }
  }

  reInitCluster() {
    if (this.unRoutedDataLayerRef) {

      if (this.markerCluster) {
        this.markerCluster.clearMarkers();
      } else {
        this.markerCluster = new MarkerClusterer(this.mapRef, null, {
          gridSize: this.clusterGridSizes.M,
          maxZoom: 12,
          styles: [
            {
              height: 49,
              width: 49,
              url: 'assets/images/icons/cluster/small.svg',
              textColor: '#424242',
              textSize: 14,
              fontWeight: 'bold'
            },
            {
              height: 64,
              width: 64,
              url: 'assets/images/icons/cluster/large.svg',
              textColor: '#424242',
              textSize: 14,
              fontWeight: 'bold'
            }],
          zoomOnClick: true
        });
      }

      this.unRoutedDataLayerRef.forEach((feature) => {
        const id = feature.getProperty('id'),
          purpose = feature.getProperty('purpose'),
          status = feature.getProperty('status'),
          jobId = feature.getProperty('jobId');

        const isDimmed = this.highlightedLeftoverIds && !this.highlightedLeftoverIds.has(jobId);

        if (!isDimmed) {
          const isSelected = _.indexOf(this.selectedJobIds, id) !== -1;

          const marker = new google.maps.Marker({
            position: (feature.getGeometry() as google.maps.Data.Point).get(),
            icon: this.mapsCommonService.getTaskMarkerIconNew(purpose, status, isSelected)
          });
          this.markerCluster.addMarker(marker);
        }
      });

      this.map.unRoutedLayerEnabled = false;
      this.markerCluster.repaint();
    }
  }

  clearCluster() {
    if (this.markerCluster) {
      const clusterMarks = this.markerCluster.getMarkers();
      for (let i in clusterMarks) {
        clusterMarks[i].setMap(null);
      }
      this.markerCluster.clearMarkers();
    }
  }


  // ******************************
  //        Private methods
  // ******************************

  private _highlightRoutePolyline(polyline: any) {
    if (this.hoveredRoutePolyline === polyline) {
      return; // Already highlighted
    }

    // Unhighlight previous
    this._unhighlightRoutePolyline();

    this.hoveredRoutePolyline = polyline;

    // Get the route's color from the feature
    const routeColor = polyline.getProperty('color') || '#FFD700';

    // Override style for highlighted polyline - use route color with enhanced visibility
    this.routesDataLayerRef.overrideStyle(polyline, {
      strokeColor: routeColor,
      strokeWeight: 6,
      strokeOpacity: 1,
      zIndex: 1000
    });
  }

  private _unhighlightRoutePolyline() {
    if (this.hoveredRoutePolyline) {
      // Reset to original style
      this.routesDataLayerRef.revertStyle(this.hoveredRoutePolyline);
      this.hoveredRoutePolyline = null;
    }
  }

  private _bindFeatureDragListeners(handlers: {
    onMove: (moveEvent: { latLng: google.maps.LatLng, pixel: google.maps.Point }) => void,
    onUp: (upEvent: { latLng: google.maps.LatLng, pixel: google.maps.Point | null }) => void,
    onCancel: () => void
  }, startDomEvent?: MouseEvent) {
    if (this.dragDomListeners) {
      const stale = this.dragDomListeners;
      this.dragDomListeners = null;
      stale.dispose();
      stale.cancel();
    }
    this.dragPolylineCache = null;

    const mapDiv: HTMLElement = this.mapRef.getDiv();

    const toPixel = (domEvent: MouseEvent) => {
      const rect = mapDiv.getBoundingClientRect();
      return new google.maps.Point(domEvent.clientX - rect.left, domEvent.clientY - rect.top);
    };

    const toMapEvent = (domEvent: MouseEvent) => {
      const pixel = toPixel(domEvent);
      const latLng = this.mapUtilsService.containerPixelToLatLng(pixel, this.mapRef);

      return latLng ? {latLng: latLng, pixel: pixel} : null;
    };

    const DRAG_THRESHOLD_PX = 4;
    let origin: google.maps.Point | null = startDomEvent ? toPixel(startDomEvent) : null;
    let hasPassedThreshold = false;
    let pendingDomEvent: MouseEvent | null = null;
    let rafId: number | null = null;

    const processMove = () => {
      rafId = null;

      const domEvent = pendingDomEvent;
      pendingDomEvent = null;
      if (!domEvent) {
        return;
      }

      const mapEvent = toMapEvent(domEvent);
      if (!mapEvent) {
        return;
      }

      if (!origin) {
        origin = mapEvent.pixel;
      }
      if (!hasPassedThreshold) {
        const dx = mapEvent.pixel.x - origin.x;
        const dy = mapEvent.pixel.y - origin.y;
        if ((dx * dx + dy * dy) < (DRAG_THRESHOLD_PX * DRAG_THRESHOLD_PX)) {
          return;
        }
        hasPassedThreshold = true;
      }

      this.lastDragLatLng = mapEvent.latLng;
      handlers.onMove(mapEvent);
    };

    const move = (domEvent: MouseEvent) => {
      pendingDomEvent = domEvent;
      if (rafId === null) {
        rafId = requestAnimationFrame(processMove);
      }
    };

    const up = (domEvent: MouseEvent) => {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      if (pendingDomEvent) {
        processMove();
      }

      const mapEvent = toMapEvent(domEvent);
      this._unbindFeatureDragListeners();
      handlers.onUp(mapEvent || {latLng: this.lastDragLatLng, pixel: null});
    };

    mapDiv.addEventListener('mousemove', move, true);
    document.addEventListener('mouseup', up, true);

    this.dragDomListeners = {
      dispose: () => {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        pendingDomEvent = null;
        mapDiv.removeEventListener('mousemove', move, true);
        document.removeEventListener('mouseup', up, true);
      },
      cancel: handlers.onCancel
    };
  }

  private _unbindFeatureDragListeners() {
    if (!this.dragDomListeners) {
      return;
    }

    this.dragDomListeners.dispose();
    this.dragDomListeners = null;
  }


  private _activityOrderIds(draggedActivity, toActivities, polylinePath) {
    // Step 1: Project each existing marker onto polyline
    const markersWithPos = toActivities.map(m => ({
      id: m.id,
      stopIds: m.stopIds?.length ? m.stopIds : [m.stopId],
      positionOnLine: this.mapUtilsService.projectPointOntoPolyline(
        new google.maps.LatLng(m.address.location.lat, m.address.location.lng),
        polylinePath
      )
    }));

    const draggedActivityGeometry = (draggedActivity.getGeometry() as google.maps.Data.Point).get()
    // Step 2: Project dragged marker
    const draggedPos = this.mapUtilsService.projectPointOntoPolyline(
      new google.maps.LatLng(draggedActivityGeometry.lat(), draggedActivityGeometry.lng()),
      polylinePath
    );

    const draggedActivityStopIds = draggedActivity.getProperty('stopIds')?.length ? draggedActivity.getProperty('stopIds') : [draggedActivity.getProperty('stopId')]
    // Step 3: Insert dragged marker in correct position
    let inserted = false;
    let newOrder: any = [];
    for (let i = 0; i < markersWithPos.length; i++) {
      if (!inserted && draggedPos < markersWithPos[i].positionOnLine) {
        newOrder = newOrder.concat(draggedActivityStopIds); // insert before current
        inserted = true;
      }
      newOrder = newOrder.concat(markersWithPos[i].stopIds); // insert before current
    }
    if (!inserted) {
      // If it's after the last marker
      newOrder = newOrder.concat(draggedActivityStopIds); // insert before current
    }

    return newOrder;
  }

  private _getBundledStopIndex(job, stopType, index: number, toRouteActivities): number {
    const pickupAddress = _.find(job.stops, {stopType: 'Pickup'})?.address;
    // Mirrors the server's location matching: same typed location (non-CUSTOM), else same coordinates
    const bundleIndex = _.findIndex(toRouteActivities, (activity: any) => activity.stopType === 'Pickup' && (
      (!!pickupAddress?.locationType && pickupAddress.locationType !== 'CUSTOM' &&
        activity.address?.locationType === pickupAddress.locationType && activity.address?.locationId === pickupAddress.locationId) ||
      (activity.address?.location?.lat === pickupAddress?.location?.lat && activity.address?.location?.lng === pickupAddress?.location?.lng)));
    if (bundleIndex < 0) {
      return index;
    }
    // The server bundles only consecutive stops, so the new pickup must land right after the existing pickup
    const afterBundleIndex = bundleIndex + 1;
    return stopType === 'Pickup' ? afterBundleIndex : Math.max(index, afterBundleIndex);
  }

  private _activityOrderIdsMultiple(draggedActivity, movingJobIds, fromRoutes, toActivities, polylinePath) {
    // Get activities for jobs being moved, maintaining their order from source route
    const movingStopIds = [];

    fromRoutes.forEach(fromRoute => {
      const sourceActivities = fromRoute.activities.filter(a => a.type === 'STOP' || a.type === 'GROUP');

      sourceActivities.forEach(activity => {
        const activityJobIds = activity.stopIds?.length > 0
          ? activity.stopIds.map(stopId => {
              const stop = fromRoute.stops?.find(s => s.id === stopId);
              return stop?.jobId;
            }).filter(Boolean)
          : [activity.jobId];

        const hasMovingJob = activityJobIds.some(jobId => movingJobIds.includes(jobId));
        if (hasMovingJob) {
          if (activity.stopIds?.length) {
            movingStopIds.push(...activity.stopIds);
          } else if (activity.stopId) {
            movingStopIds.push(activity.stopId);
          }
        }
      });
    });

    // Project each existing marker (that's not being moved) onto polyline
    const markersWithPos = toActivities
      .filter(m => {
        const activityStopIds = m.stopIds?.length ? m.stopIds : [m.stopId];
        return !activityStopIds.some(sid => movingStopIds.includes(sid));
      })
      .map(m => ({
        id: m.id,
        stopIds: m.stopIds?.length ? m.stopIds : [m.stopId],
        positionOnLine: this.mapUtilsService.projectPointOntoPolyline(
          new google.maps.LatLng(m.address.location.lat, m.address.location.lng),
          polylinePath
        )
      }));

    // Project dragged marker position
    const draggedActivityGeometry = (draggedActivity.getGeometry() as google.maps.Data.Point).get();
    const draggedPos = this.mapUtilsService.projectPointOntoPolyline(
      new google.maps.LatLng(draggedActivityGeometry.lat(), draggedActivityGeometry.lng()),
      polylinePath
    );

    // Insert all moving stops at the correct position, maintaining their order
    let inserted = false;
    let newOrder: any = [];
    for (let i = 0; i < markersWithPos.length; i++) {
      if (!inserted && draggedPos < markersWithPos[i].positionOnLine) {
        newOrder = newOrder.concat(movingStopIds);
        inserted = true;
      }
      newOrder = newOrder.concat(markersWithPos[i].stopIds);
    }
    if (!inserted) {
      newOrder = newOrder.concat(movingStopIds);
    }

    return newOrder;
  }

  private _activityOrderIdsMultipleUnrouted(draggedActivity, movingJobIds, toActivities, polylinePath) {
    // For unrouted tasks, we need to get their stopIds
    const movingStopIds = [];

    movingJobIds.forEach(jobId => {
      const job = this.jobsMap[jobId];
      if (job?.stopId) {
        movingStopIds.push(job.stopId);
      }
    });

    // Project each existing marker onto polyline
    const markersWithPos = toActivities.map(m => ({
      id: m.id,
      stopIds: m.stopIds?.length ? m.stopIds : [m.stopId],
      positionOnLine: this.mapUtilsService.projectPointOntoPolyline(
        new google.maps.LatLng(m.address.location.lat, m.address.location.lng),
        polylinePath
      )
    }));

    // Project dragged marker position
    const draggedActivityGeometry = (draggedActivity.getGeometry() as google.maps.Data.Point).get();
    const draggedPos = this.mapUtilsService.projectPointOntoPolyline(
      new google.maps.LatLng(draggedActivityGeometry.lat(), draggedActivityGeometry.lng()),
      polylinePath
    );

    // Insert all moving stops at the correct position
    let inserted = false;
    let newOrder: any = [];
    for (let i = 0; i < markersWithPos.length; i++) {
      if (!inserted && draggedPos < markersWithPos[i].positionOnLine) {
        newOrder = newOrder.concat(movingStopIds);
        inserted = true;
      }
      newOrder = newOrder.concat(markersWithPos[i].stopIds);
    }
    if (!inserted) {
      newOrder = newOrder.concat(movingStopIds);
    }

    return newOrder;
  }

  private _getSelectedRoutedJobsByRoute(): { routeId: string; jobIds: string[] }[] {
    const groups: { routeId: string; jobIds: string[] }[] = [];

    if (!this.selectedJobIds?.length || !this.routesDataLayerRef) {
      return groups;
    }

    this.routesDataLayerRef.forEach((feature) => {
      const routeId = feature.getProperty('routeId');
      if (_.includes(this.hiddenRouteIds, routeId)) {
        return;
      }

      const featureJobIds = feature.getProperty('jobId')
        ? [feature.getProperty('jobId')]
        : (feature.getProperty('jobIds') || []);

      const matchedJobIds = featureJobIds.filter(jobId => this.selectedJobIds.includes(jobId));
      if (!matchedJobIds.length) {
        return;
      }

      let group = groups.find(g => g.routeId === routeId);
      if (!group) {
        group = {routeId, jobIds: []};
        groups.push(group);
      }
      matchedJobIds.forEach(jobId => {
        if (!group.jobIds.includes(jobId)) {
          group.jobIds.push(jobId);
        }
      });
    });

    return groups;
  }

  private _getSelectedUnroutedJobs(): string[] {
    const selectedJobs: string[] = [];

    if (!this.selectedJobIds?.length || !this.unRoutedDataLayerRef) {
      return selectedJobs;
    }

    this.unRoutedDataLayerRef.forEach((feature) => {
      const featureJobIds = feature.getProperty('jobId')
        ? [feature.getProperty('jobId')]
        : (feature.getProperty('jobIds') || []);

      featureJobIds.forEach(jobId => {
        if (this.selectedJobIds.includes(jobId) && !selectedJobs.includes(jobId)) {
          selectedJobs.push(jobId);
        }
      });
    });

    return selectedJobs;
  }

  private _showMultiDragOverlay(count: number, moveEvent: any) {
    if (!this.multiDragOverlay) {
      this.multiDragOverlay = document.createElement('div');
      this.multiDragOverlay.className = 'multi-drag-overlay';
      this.multiDragOverlay.innerHTML = `
        <div class="multi-drag-badge">
          <span class="multi-drag-count">${count}</span>
        </div>
      `;
      this.mapRef.getDiv().appendChild(this.multiDragOverlay);
    }
  }

  private _updateMultiDragOverlayPosition(pixel: google.maps.Point) {
    if (this.multiDragOverlay) {
      this.multiDragOverlay.style.left = `${pixel.x + 15}px`;
      this.multiDragOverlay.style.top = `${pixel.y - 15}px`;
    }
  }

  private _hideMultiDragOverlay() {
    if (this.multiDragOverlay) {
      this.multiDragOverlay.remove();
      this.multiDragOverlay = null;
    }
  }

  private _hideSelectedFeatures(dataLayer: google.maps.Data, draggedFeature: google.maps.Data.Feature) {
    // Clear any previously hidden features
    this.hiddenDragFeatures = [];

    if (!this.selectedJobIds?.length || !dataLayer) {
      return;
    }

    dataLayer.forEach((feature) => {
      // Skip the feature being dragged - it must remain visible for drop to work
      if (feature === draggedFeature) {
        return;
      }

      const jobId = feature.getProperty('jobId');
      const jobIds = feature.getProperty('jobIds');
      const featureJobIds = (jobId ? [jobId] : (jobIds || [])) as any[];

      const isSelected = featureJobIds.some((jobId: string) => this.selectedJobIds.includes(jobId));

      if (isSelected && feature.getGeometry().getType() === "Point") {
        // Store the feature for later restoration
        this.hiddenDragFeatures.push(feature);
        // Hide the feature by making it invisible
        dataLayer.overrideStyle(feature, { visible: false });
      }
    });
  }

  private _showHiddenFeatures() {
    if (!this.hiddenDragFeatures.length) {
      return;
    }

    // Restore visibility of all hidden features
    this.hiddenDragFeatures.forEach(feature => {
      if (this.routesDataLayerRef) {
        this.routesDataLayerRef.revertStyle(feature);
      }
      if (this.unRoutedDataLayerRef) {
        this.unRoutedDataLayerRef.revertStyle(feature);
      }
    });

    // Clear the array
    this.hiddenDragFeatures = [];
  }

  private _updateFeatureSelectionByJobIds(dataLayer: google.maps.Data, changedJobIds: string[]) {
    if (!dataLayer || !changedJobIds?.length) {
      return;
    }

    dataLayer.forEach((feature) => {
      const featureJobIds = this._getFeatureJobIds(feature);
      if (featureJobIds.some(jobId => changedJobIds.includes(jobId))) {
        feature.setProperty('isSelected', featureJobIds.some(jobId => this.selectedJobIds?.includes(jobId)));
      }
    });
  }

  private _getFeatureJobIds(feature: google.maps.Data.Feature): string[] {
    const jobId = feature.getProperty('jobId');
    const jobIds = feature.getProperty('jobIds');

    if (jobId) {
      return [jobId as string];
    }

    if (Array.isArray(jobIds)) {
      return jobIds as string[];
    }

    return [];
  }

  private _buildDragPolylineCache() {
    this.dragPolylineCache = [];

    const projection = this.mapRef && this.mapRef.getProjection();
    if (!projection || !this.routesDataLayerRef || !this.filters.routes) {
      return;
    }

    this.routesDataLayerRef.forEach((feature) => {
      const geometry = feature.getGeometry();
      if (!geometry || geometry.getType() !== 'LineString') {
        return;
      }
      if (_.includes(this.hiddenRouteIds, feature.getProperty('routeId'))) {
        return;
      }

      const path = (geometry as google.maps.Data.LineString).getArray();
      if (path.length < 2) {
        return;
      }

      const world = new Float64Array(path.length * 2);
      let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;

      for (let i = 0; i < path.length; i++) {
        const point = projection.fromLatLngToPoint(path[i]);
        world[2 * i] = point.x;
        world[2 * i + 1] = point.y;
        if (point.x < minX) minX = point.x;
        if (point.x > maxX) maxX = point.x;
        if (point.y < minY) minY = point.y;
        if (point.y > maxY) maxY = point.y;
      }

      this.dragPolylineCache.push({feature, world, minX, maxX, minY, maxY});
    });
  }

  private _getClosestDragPolyline(latLng: google.maps.LatLng): google.maps.Data.Feature | null {
    const projection = this.mapRef && this.mapRef.getProjection();
    const zoom = this.mapRef && this.mapRef.getZoom();
    if (!projection || typeof zoom === 'undefined' || !latLng) {
      return null;
    }

    if (!this.dragPolylineCache) {
      this._buildDragPolylineCache();
    }

    const scale = 2 ** zoom;
    const tolerance = PlanningRoutesMapComponent.DRAG_POLYLINE_TOLERANCE_PX;
    const padWorld = tolerance / scale;
    const cursor = projection.fromLatLngToPoint(latLng);
    const px = cursor.x * scale, py = cursor.y * scale;

    let closest: google.maps.Data.Feature | null = null;
    let minDistance = tolerance;

    for (const entry of this.dragPolylineCache) {
      if (cursor.x < entry.minX - padWorld || cursor.x > entry.maxX + padWorld ||
        cursor.y < entry.minY - padWorld || cursor.y > entry.maxY + padWorld) {
        continue;
      }

      const world = entry.world;
      for (let i = 0; i + 3 < world.length; i += 2) {
        const distance = this._segmentDistancePx(
          px, py,
          world[i] * scale, world[i + 1] * scale,
          world[i + 2] * scale, world[i + 3] * scale
        );
        if (distance < minDistance) {
          minDistance = distance;
          closest = entry.feature;
        }
      }
    }

    return closest;
  }

  private _segmentDistancePx(px: number, py: number, ax: number, ay: number, bx: number, by: number): number {
    const l2 = (ax - bx) ** 2 + (ay - by) ** 2;
    if (l2 === 0) {
      return Math.sqrt((px - ax) ** 2 + (py - ay) ** 2);
    }

    const t = Math.max(0, Math.min(1, ((px - ax) * (bx - ax) + (py - ay) * (by - ay)) / l2));
    const projX = ax + t * (bx - ax);
    const projY = ay + t * (by - ay);

    return Math.sqrt((px - projX) ** 2 + (py - projY) ** 2);
  }

  private setRoutes(routes) {
    if (this.routesDataLayerRef) {

      _.forEach(routes, (r) => {
        const geoJson = this.mapsCommonService.convertRoutedActivitiesToGeoJson(r, undefined, this.isAllowDraggingStops);

        // Add routes to layer
        this.routesDataLayerRef.addGeoJson(geoJson);
      })

      // Set feature style by its properties
      this.setRoutesStyle();
    }
  }

  private setRoutesStyle() {
    if (this.routesDataLayerRef) {
      this.dragPolylineCache = null;
      this.routesDataLayerRef.setStyle((feature) => {
        return this.getRouteFeatureStyle(feature);
      });
    }
  }

  private removeRoutesByIds(routeIdsToRemove) {
    if (this.routesDataLayerRef) {
      this.dragPolylineCache = null;
      this.routesDataLayerRef.forEach((feature) => {
        if (!routeIdsToRemove || _.includes(routeIdsToRemove, feature.getProperty('routeId'))) {
          this.routesDataLayerRef.remove(feature);
        }
      });
    }
  }

  private removeRoutes() {
    if (this.routesDataLayerRef) {
      this.dragPolylineCache = null;
      this.routesDataLayerRef.forEach((feature) => {
        this.routesDataLayerRef.remove(feature);
      });
    }
  }

  private getAllMarkers() {
    const markers = [];
    if (this.routesDataLayerRef) {
      this.routesDataLayerRef.forEach((feature) => {
        const featureType = feature.getProperty('type'),
          isStop = _.isEqual(featureType, 'STOP'),
          isGroup = _.isEqual(featureType, 'GROUP');

        if (isStop || isGroup) {
          const coordinates = feature.getProperty('coordinates');
          const fakeMarker = new google.maps.MVCObject();
          fakeMarker.set('coords', {'latitude': coordinates.lat, 'longitude': coordinates.lng});
          markers.push(fakeMarker);
        }
      });
    }
    if (this.unRoutedDataLayerRef) {
      this.unRoutedDataLayerRef.forEach((feature) => {
        const coordinates = feature.getProperty('coordinates');
        const fakeMarker = new google.maps.MVCObject();
        fakeMarker.set('coords', {'latitude': coordinates.lat, 'longitude': coordinates.lng});
        markers.push(fakeMarker);
      });
    }
    return markers;
  }

  private setGoogleMarkerIcon(marker, selectedId, highlightedId) {
    const modelRef = marker.model,
      isStop = _.isEqual(modelRef.type, 'STOP'),
      isGroup = _.isEqual(modelRef.type, 'GROUP');

    const icon = (isStop || isGroup) ?
      this.mapsCommonService.buildActivityIcon(
        _.isEqual(modelRef.id, selectedId),
        _.isEqual(modelRef.id, highlightedId),
        modelRef.routeColor,
        isGroup,
        modelRef.markerIndex + 1
      ) :
      this.mapsCommonService.buildStartEndPointIcon(
        _.isEqual(modelRef.id, highlightedId)
      );
    marker.setIcon(icon);
  }

  private setActivityInfoWindow(jobId, model, lat, lng) {
    this.jobInfoWindow.coords = {
      lat: lat,
      latitude: lat,
      lng: lng,
      longitude: lng
    };

    const jobRef = _.find(this.jobs, (j) => {
      return j.id === jobId;
    })

    this.jobInfoWindowModel = {
      id: model.id,
      eta: model.eta,
      address: model.address,
      routeId: model.routeId,
      accountName: model.stopActivities?.length ? model.stopActivities[0].accountName : model.accountName,
      notBefore: model.notBefore,
      notAfter: model.notAfter,
      packages: model.packages,
      tagNames: jobRef?.tags,
      skills: jobRef?.requiredSkills,
      stopType: model.stopType,
      isSubset: !!this.filters.stopsTooltipSubset
    };
    this.jobInfoWindow.show = true;
  }

  private unsetActivityInfoWindow() {
    this.hoveringTaskId = undefined;
    this.jobInfoWindowModel = undefined;
    this.jobInfoWindow.show = false;
  }

  private getJobIdsByBounds(bounds: google.maps.LatLngBounds) {
    var jobIds = [];

    if (!!this.filters.unRouted && !!this.unRoutedDataLayerRef) {
      this.unRoutedDataLayerRef.forEach((feature) => {
        const coordinates = feature.getProperty('coordinates'),
          activityJobIds = feature.getProperty('jobId') ? [feature.getProperty('jobId')] : feature.getProperty('jobIds');

        if (bounds.contains({lat: coordinates.lat, lng: coordinates.lng})) {
          jobIds = jobIds.concat(activityJobIds);
        }
      });
    }

    if (this.routesDataLayerRef) {
      this.routesDataLayerRef.forEach((feature) => {
        const coordinates = feature.getProperty('coordinates');
        const routeId = feature.getProperty('routeId');
        if ((!_.includes(this.hiddenRouteIds, routeId)) &&
          (coordinates && coordinates.lat && coordinates.lng) &&
          (bounds.contains({lat: coordinates.lat, lng: coordinates.lng}))
        ) {
          const activityJobIds = feature.getProperty('jobId') ? [feature.getProperty('jobId')] : feature.getProperty('jobIds');

          if (activityJobIds.length) {
            jobIds = jobIds.concat(activityJobIds);
          }
        }
      });
    }

    return jobIds;
  }

  private _handleClusterClick(cluster: StopsClusterModel) {
    const routeIds = [];
    const jobIds = [];

    this.routesDataLayerRef.forEach((feature) => {
      const coordinates = feature.getProperty('coordinates');
      const routeId = feature.getProperty('routeId');

      if (!coordinates || !routeId) {
        return;
      }

      if (cluster.points.some(point => point[1] === coordinates.lat && point[0] === coordinates.lng)) {
        routeIds.push(routeId);
      }
    });

    this.unRoutedDataLayerRef.forEach((feature) => {
      const coordinates = feature.getProperty('coordinates');
      const jobId = feature.getProperty('jobId');

      if (!coordinates || !jobId) {
        return;
      }

      if (cluster.points.some(point => point[1] === coordinates.lat && point[0] === coordinates.lng)) {
        jobIds.push(jobId);
      }
    });

    this.onClusterToggle({ clusterId: cluster.clusterHashId, routeIds: routeIds, jobIds: jobIds });
  }

  private _setClusteringAreaPolygons() {
    const hasClusteringAreas = !!this.clusteringAreas?.length;
    if (hasClusteringAreas && !this.stopsClusters?.length &&
      !this.isClustersLayerUserSet && !this.isClustersLayerAutoEnabled) {
      this.isClustersLayerAutoEnabled = true;
      this.filters.clusters = true;
    }

    this.clusteringAreaPolygons = this.mapsCommonService.buildClusteringAreaPolygons(
      this.clusteringAreas || [],
      this.filters.clusters
    );
  }

  // 'Planned Routes' is the master show-all/hide-all state of the route layer: checked unless
  // every known route is hidden. Compared against the current route set so ids left over from
  // deleted routes cannot make it stale.
  private _syncRoutesFilter() {
    const routeIds = _.map(this.routes, 'id');
    const hiddenIds = _.intersection(this.hiddenRouteIds || [], routeIds);

    this.filters.routes = !routeIds.length || hiddenIds.length !== routeIds.length;
  }

  private _getPersistedFilterKeys(): string[] {
    return _.without(_.keys(this.filters), 'routes');
  }

  private _restoreMapLayers() {
    if (!this.mapLayers) {
      return;
    }

    this.filters = {...this.filters, ..._.pick(this.mapLayers, this._getPersistedFilterKeys())};

    if (!_.isUndefined(this.mapLayers.doCluster)) {
      this.map.doCluster = this.mapLayers.doCluster;
    }

    this.isClustersLayerUserSet = !!this.mapLayers.clustersUserSet;

    // These layers need their imperative side effects applied, not just the flag set.
    this._applyMapType(this.filters.satellite);
    this._applyUnRoutedLayer(this.filters.unRouted);
    this._applyClusteringAreasVisibility();
  }

  private _emitMapLayersChange() {
    if (!this.onMapLayersChange) {
      return;
    }

    const layers: MapLayersSettings = {
      ..._.pick(this.filters, this._getPersistedFilterKeys()),
      clustersUserSet: this.isClustersLayerUserSet,
      doCluster: this.map.doCluster
    };

    this.onMapLayersChange({layers: layers});
  }
}

angular
  .module('bringoz.admin.map')
  .component('planningRoutesMap', {
    bindings: {
      routes: '<',
      jobs: '<?',
      depots: '<',
      stopsClusters: '<',
      hiddenRouteIds: '<',
      unRoutedStops: '<',
      serviceAreas: '<',
      clusteringAreas: '<?',
      suggestions: '<?',
      selectedJobIds: '<?',
      selectedActivityId: '<?',
      zoomActivityId: '<?',
      highlightedActivityId: '<?',
      isDisplayRetrips: '<?',
      isValidateRouteVehicles: '<?',
      isAllowDraggingStops: '<?',
      isAllowDraggingIntoDispatchedRoute: '<?',
      highlightedRouteIds: '<?',
      highlightedLeftoverIds: '<?',
      mapLayers: '<?',
      onMapLayersChange: '&?',
      onRoutedJobSelect: '&',
      onUnRoutedJobSelect: '&',
      onUnRoutedMultipleJobsSelect: '&',
      onActivityHover: '&',
      onActivityHighlight: '&',
      onRoutedActivitySelect: '&',
      onAddStopsToRoute: '&',
      onHiddenRouteIdsChange: '&',
      onSelectRoute: '&',
      onViewJob: '&',
      onChangeRouteResource: '&',
      selectedServiceIdsChanged: '&',
      onMoveActivity: '&',
      onClusterToggle: '&'
    },
    template: require('./planning-routes-map.html').default,
    controller: PlanningRoutesMapComponent
  });
